.root {
  margin: auto;
}

.logo {
  margin-bottom: 10px;
  justify-content: center;
}

.error {
  position: relative;
  padding: 10px;
  line-height: 1;
}

.error > *:not(:last-child) {
  margin-bottom: 10px;
}
